/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  GeneratePayRunRequest,
  PayRunDetail,
  PayRunIdRequest,
  PayRunSummary,
} from "../models/index";
import {
  GeneratePayRunRequestFromJSON,
  GeneratePayRunRequestToJSON,
  PayRunDetailFromJSON,
  PayRunDetailToJSON,
  PayRunIdRequestFromJSON,
  PayRunIdRequestToJSON,
  PayRunSummaryFromJSON,
  PayRunSummaryToJSON,
} from "../models/index";

export interface FinalizePayRunRequest {
  payRunIdRequest: PayRunIdRequest;
}

export interface GeneratePayRunOperationRequest {
  generatePayRunRequest: GeneratePayRunRequest;
}

export interface GetPayRunRequest {
  payRunId: string;
}

/**
 *
 */
export class PeoplePayrollApi extends runtime.BaseAPI {
  /**
   */
  async finalizePayRunRaw(
    requestParameters: FinalizePayRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["payRunIdRequest"] == null) {
      throw new runtime.RequiredError(
        "payRunIdRequest",
        'Required parameter "payRunIdRequest" was null or undefined when calling finalizePayRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/payroll/finalize`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PayRunIdRequestToJSON(requestParameters["payRunIdRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async finalizePayRun(
    requestParameters: FinalizePayRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.finalizePayRunRaw(requestParameters, initOverrides);
  }

  /**
   */
  async generatePayRunRaw(
    requestParameters: GeneratePayRunOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PayRunIdRequest>> {
    if (requestParameters["generatePayRunRequest"] == null) {
      throw new runtime.RequiredError(
        "generatePayRunRequest",
        'Required parameter "generatePayRunRequest" was null or undefined when calling generatePayRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/payroll/generate`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: GeneratePayRunRequestToJSON(
          requestParameters["generatePayRunRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PayRunIdRequestFromJSON(jsonValue),
    );
  }

  /**
   */
  async generatePayRun(
    requestParameters: GeneratePayRunOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PayRunIdRequest> {
    const response = await this.generatePayRunRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getPayRunRaw(
    requestParameters: GetPayRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PayRunDetail>> {
    if (requestParameters["payRunId"] == null) {
      throw new runtime.RequiredError(
        "payRunId",
        'Required parameter "payRunId" was null or undefined when calling getPayRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["payRunId"] != null) {
      queryParameters["payRunId"] = requestParameters["payRunId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/payroll/get`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PayRunDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getPayRun(
    requestParameters: GetPayRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PayRunDetail> {
    const response = await this.getPayRunRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async listPayRunsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<PayRunSummary>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/payroll/list`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(PayRunSummaryFromJSON),
    );
  }

  /**
   */
  async listPayRuns(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<PayRunSummary>> {
    const response = await this.listPayRunsRaw(initOverrides);
    return await response.value();
  }
}
